<template>
  <div v-show="visible && activated" class="fdd-subpage">
    <slot />
  </div>
</template>

<script>
  import mount from '@/mixins/mount'

  export default {
    name: 'FddSubpage',
    mixins: [mount],
    props: {
      mount: String // 指定挂载容器选择器
    },

    data() {
      return {
        visible: true
      }
    }
  }
</script>

<style lang="less" scoped>
  .fdd-subpage {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 8;
    background: #f8f8f8;

    &.hidden {
      display: none;
    }
  }
</style>
